export const updateDatiTakeProfit = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};